import React, { useState } from "react";
import "./styles.css";
import { SideMenu } from "./SideMenu/SideMenu";
import { Leads } from "./Leads/Leads";


export default function App() {
  const [selectedStore, setSelectedStore] = useState("walmart");

  return (
    <div className="app-container">
      <SideMenu setSelectedStore={setSelectedStore} />
      <Leads selectedStore={selectedStore} />
    </div>
  );
}
